import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "flex",
        width: "100%",
        padding: "2px",
    },
    label: {
        flex: "0 0 30%",
        textAlign: "justify",
        fontSize: "14px",
    },
    value: {
        flex: "1",
        textAlign: "left",
        fontSize: "14px",
    },
    clickableText: {
        color: "lightblue",
        cursor: "pointer",
        display: "inline-block",
        fontSize: "14px",
    },
}));

export default useStyles;
